
type Timestamp = {
	seconds: number,
	nanoseconds: number,
};

export type Pos = {
	x: number,
	y: number,
};

export type State = PreparationState | PlayingState;

export type PreparationState = {
	type: 'preparation',

	name: string,
	public: boolean,
	ownerId: string,
	createdAt: Timestamp,

	users: { [key: string]: User },
};

export type PlayingState = {
	type: 'started' | 'finished',

	name: string,
	public: boolean,
	ownerId: string,
	createdAt: Timestamp,
	
	users: { [key: string]: Player },

	startedAt: Timestamp,
	initialScheduleAt: Timestamp,
	
	width: number,
	height: number,

	// Game parameters
	scheduleInterval: number, // in hours
	scheduleActionPointsPerAlive: number, 
	scheduleVotesPerDead: number,
	scheduleVotesToActionPoints: number,

	rangeUpgradeCost: number,
	healCost: number,
};

export type User = {
	joinedAt: Timestamp,
	nickname: string,
	// Should 'status' and 'info' be room-specific?
	status: string,
	info: string,
};
export type Player = {
	joinedAt: Timestamp,
	nickname: string,
	// Should 'status' and 'info' be room-specific?
	status: string,
	info: string,

	health: number,
	actionPoints: number,
	range: number,
	pos: Pos,
	// Dead jury stuff
	votesReceived: number,
	votesAvailable: number,
};

// roomStates/{roomId}/messages/{messageId}
export type Message = {
	authorId: string,
	createdAt: Timestamp,
	body: string,
};

// roomStates/{roomId}/actions/{actionId}
export type Action =
	| StartGame
	| ResetGame
	| Schedule
	| SetStatus
	| Move
	| Shoot
	| Transfer
	| Upgrade
	| Heal
	| Vote
	| TestDistributePoints;

export enum ActionType {
	StartGame = 'game-started',
	ResetGame = 'game-reset',
	Schedule = 'schedule',
	SetStatus = 'set-status',
	Move = 'move',
	Shoot = 'shoot',
	Transfer = 'transfer',
	Upgrade = 'upgrade',
	Heal = 'heal',
	Vote = 'vote',
	TestDistributePoints = 'distribute-points',
};

export type StartGame = {
	type: ActionType.StartGame,

	// User initial properties
	positions: { [key: string]: Pos },
	health: number,
	actionPoints: number,
	range: number,

	startedAt: Timestamp,
	initialScheduleAt: Timestamp,

	parameters: {
		width: number,
		height: number,
		
		// Game parameters
		scheduleInterval: number, // in hours
		scheduleActionPointsPerAlive: number, 
		scheduleVotesPerDead: number,
		scheduleVotesToActionPoints: number,

		rangeUpgradeCost: number,
		healCost: number,
	},
};

export type ResetGame = {
	type: ActionType.ResetGame,
};

export type Schedule = {
	type: ActionType.Schedule,
};

export type SetStatus = {
	type: ActionType.SetStatus,
	actorId: string,
	status: string,
};

export type Move = {
	type: ActionType.Move,
	actorId: string,
	to: Pos,
};

export type Shoot = {
	type: ActionType.Shoot,
	actorId: string,
	shootedPlayerId: string,
	count: number,
	to: Pos, // Double checking
};

export type Transfer = {
	type: ActionType.Transfer,
	actorId: string,
	receiverId: string,
	actionPoints: number,
	healthPoints: number,
	// Should I double check here as well? : to: Pos
};

export type Upgrade = {
	type: ActionType.Upgrade,
	actorId: string,
	count: number,
};

export type Heal = {
	type: ActionType.Heal,
	actorId: string,
	count: number,
};

export type Vote = {
	type: ActionType.Vote,
	actorId: string,
	receiverId: string,
	count: number,
};

export type TestDistributePoints = {
	type: ActionType.TestDistributePoints,
	actionPoints: number,
	healthPoints: number,
	deadReceiveActionPoints: boolean,
	deadReceiveHealthPoints: boolean,
};

// Deprecated or delayed

export type Room = {
	name: string,
	createdAt: Timestamp,
};
